import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  tabindex: "-1",
  ref: "modalEl"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h5", { class: "modal-title" }, "Opening Logic World", -1)
const _hoisted_6 = { class: "modal-body" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("button", {
            class: "btn-close",
            onClick: _cache[0] || (_cache[0] = $event => ($setup.modal?.hide()))
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("p", null, [
            _createTextVNode("If you don't own Logic World yet, you can get it "),
            _createVNode(_component_router_link, {
              to: "/wishlist",
              onClick: $setup.hide
            }, {
              default: _withCtx(() => [
                _createTextVNode("here")
              ]),
              _: 1
            }),
            _createTextVNode(".")
          ]),
          _createElementVNode("p", null, [
            _createTextVNode("If Logic World isn't opening, click "),
            _createVNode(_component_router_link, {
              to: "/view/pst-56609d78",
              onClick: $setup.hide
            }, {
              default: _withCtx(() => [
                _createTextVNode("here")
              ]),
              _: 1
            }),
            _createTextVNode(".")
          ]),
          _createElementVNode("div", { class: "d-flex justify-content-end mt-3" }, [
            _createElementVNode("button", {
              class: "btn btn-secondary me-3",
              onClick: $setup.onDontShowAgain
            }, "Don't show again"),
            _createElementVNode("button", {
              class: "btn btn-primary",
              onClick: $setup.hide
            }, "Got it")
          ])
        ])
      ])
    ])
  ], 512))
}